<template>
  <landing></landing>
</template>

<script>
import Landing from './Landing.vue'
export default {
  name: 'baseTemplate',
  components: {
    Landing
  },
  beforeCreate () {
    if (this.$store.state.auth.user.id) {
      this.$router.push({ name: 'admin-applicants' })
    }
  }
}
</script>
